// ng2 polyfills
import 'reflect-metadata';
import 'zone.js/dist/zone';
